import React from 'react';
import { Breadcrumb, ChevronEndIcon, Text } from '@fluentui/react-northstar';
import { Link } from 'react-router-dom';

export interface BreadcrumbProperties {
  title: string;
  link: string;
  notALink?: boolean;
  onClickHandler?: () => void;
}

export interface Breadcrumbs {
  breadcrumbs: BreadcrumbProperties[];
}

export const BreadcrumbNavigation = (props: Breadcrumbs) => {
  return (
    <Breadcrumb style={{ marginRight: '.5rem', marginLeft: '.75rem' }} aria-label="breadcrumb">
      {props.breadcrumbs.map(function (item, index) {
        return (
          <>
            {props.breadcrumbs.length != 1 &&
              props.breadcrumbs.length != index + 1 && (
                <>
                  <Breadcrumb.Item>
                    {item.notALink && item.link.length == 0
                      ? <span style={{ cursor: "pointer" }} onClick={item.onClickHandler}>{item.title}</span>
                      : <Link to={item.link}>{item.title}</Link>}
                  </Breadcrumb.Item>
                  <Breadcrumb.Divider>
                    <Text content={<ChevronEndIcon />} />
                  </Breadcrumb.Divider>
                </>
              )}
            {props.breadcrumbs.length == index + 1 && (
              <Breadcrumb.Item aria-current="page">
                <Text content={item.title} weight={'bold'} />
              </Breadcrumb.Item>
            )}
          </>
        );
      })}
    </Breadcrumb>
  );
};

export const MobileBreadcrumbs = (props: Breadcrumbs) => {
  return (
    <nav aria-label="breadcrumb" className="ms-FocusZone ui-breadcrumb inline-flex items-center">
      <div role='list' className='flex items-center w-screen md:w-auto'>
        {props.breadcrumbs.map((item, idx) => <>
          {props.breadcrumbs.length != 1 && props.breadcrumbs.length != idx + 1 && (<>
            <div role="listitem" className="ui-breadcrumb__item inline-flex items-center align-middle gap-2 px-3 whitespace-nowrap">
              {item.notALink && item.link.length == 0 ? <span style={{ cursor: "pointer" }} onClick={item.onClickHandler}>{item.title}</span> : <Link to={item.link}>{item.title}</Link>}
            </div>
            <span aria-hidden="true" className="ui-breadcrumb__divider align-middle"><Text content={<ChevronEndIcon />} /></span>
          </>)}
          {props.breadcrumbs.length == idx + 1 && (
            <div role="listitem" aria-current="page" className="ui-breadcrumb__item inline-flex items-center align-middle gap-2 px-3 overflow-hidden">
              <Text content={item.title} weight={'bold'} className='w-full whitespace-nowrap overflow-ellipsis overflow-hidden' />
            </div>
          )}
        </>)}
      </div>
    </nav>
  )
}
